import { BaseDto } from './base.dto';

/**
 * Product Search Type DTO
 */
export class ProductSearchTypeDto extends BaseDto {
  /**
   * Name of the service type.
   * @see {@link PosProductSearchNameValueEnum}
   */
  name: string;
  key: string;
}
